import type { ReactNode } from 'react';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  width?: number;
}

/**
 * Plain, dependency-free modal (no portal library, no flow-studio-local ModalPortal) — this
 * package must not assume a specific overlay/portal mechanism is available in the host app.
 * Fixed-position overlay + centered panel, same visual language across Agent/Credential/Team
 * dialogs in this package (see aiAgentAdmin.css's .aaa-modal-* classes).
 */
export function Modal({ isOpen, onClose, title, children, footer, width = 640 }: ModalProps) {
  if (!isOpen) return null;

  return (
    <div className="aaa-modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="aaa-modal" style={{ maxWidth: width }} role="dialog" aria-modal="true" aria-label={title}>
        <div className="aaa-modal-header">
          <h3>{title}</h3>
          <button type="button" className="aaa-modal-close" onClick={onClose} aria-label="Close">
            &times;
          </button>
        </div>
        <div className="aaa-modal-body">{children}</div>
        {footer && <div className="aaa-modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
